import Item from "../Item/Item"

const ItemList = ({ products }) => {
    const safeProducts = Array.isArray(products) ? products : []

    return (
        <div id="products_container" className="row mt-5">
            {safeProducts.map(prod => <Item key={prod.id} {...prod} />)}
        </div>
    )
}

export default ItemList
